import * as React from "react";
import { observer } from "mobx-react";

import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { WizardHotelPWAv2Props, WizardHotelPWAv2FTNodeOptions } from "../../typings";
import { WizardForm } from "./WizardForm";
import { WizardMobile } from "./WizardMobile";
import { StackedSticky } from "components/shared/StackedSticky/StackedSticky";
import { normalizeOptionsData } from "src/components/flexFramework/FlexTemplateNode";

export const WizardHotelPWAv2RowView: React.FC<WizardHotelPWAv2Props> = observer((props) => {
  const { context, wizardState, analytics, flexTemplateNode, flexModuleModelStore } = props;

  const model = flexModuleModelStore.getModel(flexTemplateNode.id);
  const { desktopAutoOpenCalendar } = normalizeOptionsData(flexTemplateNode, model) as WizardHotelPWAv2FTNodeOptions;

  const wizardFormProps = {
    flexTemplateNode,
    wizardState,
    analytics,
    context,
    flexModuleModelStore,
    desktopAutoOpenCalendar,
  };

  // TODO: Implement StackedSticky on WizardMobile component as well as we are
  // doing on medium and mayor devices

  return (
    <div className="WizardHotelPWAv2Row WizardHotelPWA WizardHotelPWAv2HTG">
      <Viewport>
        <ViewSmall>
          <WizardMobile {...wizardFormProps} isDesktop={false} />
        </ViewSmall>
        <ViewMedium>
          <StackedSticky>
            <WizardForm {...wizardFormProps} isDesktop />
          </StackedSticky>
        </ViewMedium>
      </Viewport>
    </div>
  );
});

export default WizardHotelPWAv2RowView;
